import React from 'react';
import get from 'lodash/get';
import ThresholdNormalIco from '@icons/noc/threshold-normal.svg';
import ThresholdCriticalIco from '@icons/noc/threshold-critical.svg';
import ThresholdWarningIco from '@icons/noc/threshold-warning.svg';
import { IconWrap, StyledEllipsisTooltip, ScopeWrapper, Span } from './styled';
import { Category } from './utils';
import { useDetectError } from '../../useDetectError';
import FilterError from '../../FilterError';

const getThresholdIcon = (category: Category) => {
  switch (category) {
    case Category.Good:
      return (
        <IconWrap>
          <ThresholdNormalIco />
        </IconWrap>
      );
    case Category.Warning:
      return (
        <IconWrap>
          <ThresholdWarningIco />
        </IconWrap>
      );
    case Category.Critical:
      return (
        <IconWrap>
          <ThresholdCriticalIco />
        </IconWrap>
      );
    default:
      return (
        <IconWrap>
          <Span />
        </IconWrap>
      );
  }
};

const Scope = ({ text, rowData }) => {
  const { error } = useDetectError();

  let thresholdCategory = get(rowData, ['threshold', rowData.id], null);
  if (thresholdCategory === Category.Good) {
    const isWarning = get(rowData, ['threshold', 'isWarning'], false);
    thresholdCategory = isWarning ? Category.Warning : Category.Good;
  }

  return (
    <ScopeWrapper>
      {getThresholdIcon(thresholdCategory)}
      <StyledEllipsisTooltip tooltipText={text}>{text}</StyledEllipsisTooltip>
      {error.filter[text] && (
        <IconWrap>
          <FilterError />
        </IconWrap>
      )}
    </ScopeWrapper>
  );
};

export default React.memo(Scope);
